/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ahir",
        "-2": "abans-d’ahir",
        "0": "avui",
        "1": "demà",
        "2": "demà passat",
        "future": {
          "one": "d’aquí a {0} dia",
          "other": "d’aquí a {0} dies"
        },
        "past": {
          "one": "fa {0} dia",
          "other": "fa {0} dies"
        }
      },
      "day-narrow": {
        "-1": "ahir",
        "-2": "abans-d’ahir",
        "0": "avui",
        "1": "demà",
        "2": "demà passat",
        "future": {
          "one": "d’aquí a {0} dia",
          "other": "d’aquí a {0} dies"
        },
        "past": {
          "one": "fa {0} dia",
          "other": "fa {0} dies"
        }
      },
      "day-short": {
        "-1": "ahir",
        "-2": "abans-d’ahir",
        "0": "avui",
        "1": "demà",
        "2": "demà passat",
        "future": {
          "one": "d’aquí a {0} dia",
          "other": "d’aquí a {0} dies"
        },
        "past": {
          "one": "fa {0} dia",
          "other": "fa {0} dies"
        }
      },
      "hour": {
        "0": "aquesta hora",
        "future": {
          "one": "d’aquí a {0} hora",
          "other": "d’aquí a {0} hores"
        },
        "past": {
          "one": "fa {0} hora",
          "other": "fa {0} hores"
        }
      },
      "hour-narrow": {
        "0": "aquesta hora",
        "future": {
          "one": "d‘aquí a {0} h",
          "other": "d‘aquí a {0} h"
        },
        "past": {
          "one": "fa {0} h",
          "other": "fa {0} h"
        }
      },
      "hour-short": {
        "0": "aquesta hora",
        "future": {
          "one": "d’aquí a {0} h",
          "other": "d’aquí a {0} h"
        },
        "past": {
          "one": "fa {0} h",
          "other": "fa {0} h"
        }
      },
      "minute": {
        "0": "aquest minut",
        "future": {
          "one": "d’aquí a {0} minut",
          "other": "d’aquí a {0} minuts"
        },
        "past": {
          "one": "fa {0} minut",
          "other": "fa {0} minuts"
        }
      },
      "minute-narrow": {
        "0": "aquest minut",
        "future": {
          "one": "d’aquí a {0} min",
          "other": "d’aquí a {0} min"
        },
        "past": {
          "one": "fa {0} min",
          "other": "fa {0} min"
        }
      },
      "minute-short": {
        "0": "aquest minut",
        "future": {
          "one": "d’aquí a {0} min",
          "other": "d’aquí a {0} min"
        },
        "past": {
          "one": "fa {0} min",
          "other": "fa {0} min"
        }
      },
      "month": {
        "-1": "el mes passat",
        "0": "aquest mes",
        "1": "el mes que ve",
        "future": {
          "one": "d’aquí a {0} mes",
          "other": "d’aquí a {0} mesos"
        },
        "past": {
          "one": "fa {0} mes",
          "other": "fa {0} mesos"
        }
      },
      "month-narrow": {
        "-1": "el mes passat",
        "0": "aquest mes",
        "1": "el mes que ve",
        "future": {
          "one": "d’aquí a {0} mes",
          "other": "d’aquí a {0} mesos"
        },
        "past": {
          "one": "fa {0} mes",
          "other": "fa {0} mesos"
        }
      },
      "month-short": {
        "-1": "el mes passat",
        "0": "aquest mes",
        "1": "el mes que ve",
        "future": {
          "one": "d’aquí a {0} mes",
          "other": "d’aquí a {0} mesos"
        },
        "past": {
          "one": "fa {0} mes",
          "other": "fa {0} mesos"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "el trimestre passat",
        "0": "aquest trimestre",
        "1": "el trimestre que ve",
        "future": {
          "one": "d’aquí a {0} trimestre",
          "other": "d’aquí a {0} trimestres"
        },
        "past": {
          "one": "fa {0} trimestre",
          "other": "fa {0} trimestres"
        }
      },
      "quarter-narrow": {
        "-1": "trim. passat",
        "0": "aquest trim.",
        "1": "trim. vinent",
        "future": {
          "one": "d’aquí a {0} trim.",
          "other": "d’aquí a {0} trim."
        },
        "past": {
          "one": "fa {0} trim.",
          "other": "fa {0} trim."
        }
      },
      "quarter-short": {
        "-1": "el trim. passat",
        "0": "aquest trim.",
        "1": "el trim. que ve",
        "future": {
          "one": "d’aquí a {0} trim.",
          "other": "d’aquí a {0} trim."
        },
        "past": {
          "one": "fa {0} trim.",
          "other": "fa {0} trim."
        }
      },
      "second": {
        "0": "ara",
        "future": {
          "one": "d’aquí a {0} segon",
          "other": "d’aquí a {0} segons"
        },
        "past": {
          "one": "fa {0} segon",
          "other": "fa {0} segons"
        }
      },
      "second-narrow": {
        "0": "ara",
        "future": {
          "one": "d’aquí a {0} s",
          "other": "d’aquí a {0} s"
        },
        "past": {
          "one": "fa {0} s",
          "other": "fa {0} s"
        }
      },
      "second-short": {
        "0": "ara",
        "future": {
          "one": "d’aquí a {0} s",
          "other": "d’aquí a {0} s"
        },
        "past": {
          "one": "fa {0} s",
          "other": "fa {0} s"
        }
      },
      "week": {
        "-1": "la setmana passada",
        "0": "aquesta setmana",
        "1": "la setmana que ve",
        "future": {
          "one": "d’aquí a {0} setmana",
          "other": "d’aquí a {0} setmanes"
        },
        "past": {
          "one": "fa {0} setmana",
          "other": "fa {0} setmanes"
        }
      },
      "week-narrow": {
        "-1": "la setm. passada",
        "0": "aquesta setm.",
        "1": "la setm. que ve",
        "future": {
          "one": "d’aquí a {0} setm.",
          "other": "d’aquí a {0} setm."
        },
        "past": {
          "one": "fa {0} setm.",
          "other": "fa {0} setm."
        }
      },
      "week-short": {
        "-1": "la setm. passada",
        "0": "aquesta setm.",
        "1": "la setm. que ve",
        "future": {
          "one": "d’aquí a {0} setm.",
          "other": "d’aquí a {0} setm."
        },
        "past": {
          "one": "fa {0} setm.",
          "other": "fa {0} setm."
        }
      },
      "year": {
        "-1": "l’any passat",
        "0": "enguany",
        "1": "l’any que ve",
        "future": {
          "one": "d’aquí a {0} any",
          "other": "d’aquí a {0} anys"
        },
        "past": {
          "one": "fa {0} any",
          "other": "fa {0} anys"
        }
      },
      "year-narrow": {
        "-1": "l’any passat",
        "0": "enguany",
        "1": "l’any que ve",
        "future": {
          "one": "d’aquí a {0} any",
          "other": "d’aquí a {0} anys"
        },
        "past": {
          "one": "fa {0} any",
          "other": "fa {0} anys"
        }
      },
      "year-short": {
        "-1": "l’any passat",
        "0": "enguany",
        "1": "l’any que ve",
        "future": {
          "one": "d’aquí a {0} any",
          "other": "d’aquí a {0} anys"
        },
        "past": {
          "one": "fa {0} any",
          "other": "fa {0} anys"
        }
      }
    },
    "locale": "ca-IT"
  });
}